import { render, staticRenderFns } from "./BetInAcceptance.vue?vue&type=template&id=647f5a8c&scoped=true"
import script from "./BetInAcceptance.vue?vue&type=script&lang=js"
export * from "./BetInAcceptance.vue?vue&type=script&lang=js"
import style0 from "./BetInAcceptance.vue?vue&type=style&index=0&id=647f5a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f5a8c",
  null
  
)

export default component.exports